export default function ({extVersionType, extStatus}) {
  return extVersionType == 3 && extStatus != 0
}